// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '../fetchBaseQuery';

// initialize an empty api service that we'll inject endpoints into later as needed
const authBase = createApi({
    reducerPath: 'authBase',
    baseQuery: fetchBaseQuery(),
    tagTypes: [
        'authProgress',
        'joiningTeams',
        'welcomeData',
        'joiningTeamsWaitingApproval',
        'joiningTeamsWaitingApproval',
        'unhandledJoinTeamRequests',
        'cards',
        'teamContributors',
        'userGroups',
        'Contributor',
    ],
    endpoints: () => ({}),
});

export default authBase;
